import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import crypto from 'crypto-js'; // Import crypto-js for MD5 hashing
import Login from './auth/Login';
import Signup from './auth/Signup';
import MainLayout from './MainLayout';
import ForgotPassword from './auth/ForgotPassword';
import ResetPassword from './auth/ResetPassword';
import VerifyEmail from './auth/VerifyEmail';
import Horoscope from './pages/Horoscope';
import Learn from './pages/Learn';
import Numero from './pages/Numero';
import Tarot from './pages/Tarot';
import Compatiblity from './pages/Compatiblity';
import KundliMatching from './pages/KundliMatching';
import LoveCompatibility from './pages/LoveCompatibility';
import LoveTarot from './pages/LoveTarot';
import DailyTarot from './pages/DailyTarot';
import WorkCompatibility from './pages/WorkCompatibility';
import ChineseCompatibility from './pages/ChineseCompatibility';
import ScrollToTop from './pages/ScrollToTop';
import WorldCard from './pages/DailyTarot/WorldCard';
import EmperorCards from './pages/DailyTarot/EmperorCards';
import ChariotCard from './pages/DailyTarot/ChariotCard';
import HangedmanCard from './pages/DailyTarot/HangedmanCard';
import DeathCard from './pages/DailyTarot/DeathCard';
import HermitCard from './pages/DailyTarot/HermitCard';
import Hieropant from './pages/DailyTarot/Hieropant';
import Justicecard from './pages/DailyTarot/Justicecard';
import LoverCard from './pages/DailyTarot/LoverCard';
import MoonCard from './pages/DailyTarot/MoonCard';
import PriestessCard from './pages/DailyTarot/PriestessCard';
import StarCard from './pages/DailyTarot/StarCard';
import SunCard from './pages/DailyTarot/SunCard';
import TemperanceCard from './pages/DailyTarot/TemperanceCard';
import TowerCard from './pages/DailyTarot/TowerCard';
import WheelfortuneCard from './pages/DailyTarot/WheelfortuneCard';
import CareerTarot from './pages/CareerTarot';
import ChariotLove from './pages/LoveTarot/ChariotLove';
import WorldLove from './pages/LoveTarot/WorldLove';
import EmperorLove from './pages/LoveTarot/EmperorLove';
import HangedmanLove from './pages/LoveTarot/HangedmanLove';
import DeathLove from './pages/LoveTarot/DeathLove';
import HermitLove from './pages/LoveTarot/HermitLove';
import HieropantLove from './pages/LoveTarot/HieropantLove';
import JusticeLove from './pages/LoveTarot/JusticeLove';
import LoverLove from './pages/LoveTarot/LoverLove';
import MoonLove from './pages/LoveTarot/MoonLove';
import PriestessLove from './pages/LoveTarot/PriestessLove';
import StarLove from './pages/LoveTarot/StarLove';
import SunLove from './pages/LoveTarot/SunLove';
import TemperanceLove from './pages/LoveTarot/TemperanceLove';
import TowerLove from './pages/LoveTarot/TowerLove';
import WheelfortuneLove from './pages/LoveTarot/WheelfortuneLove';
import WorldCareer from './pages/CareerTarot/WorldCareer';
import EmperorCareer from './pages/CareerTarot/EmperorCareer';
import ChariotCareer from './pages/CareerTarot/ChariotCareer';
import HangedmanCareer from './pages/CareerTarot/HangedmanCareer';
import DeathCareer from './pages/CareerTarot/DeathCareer';
import HieropantCareer from './pages/CareerTarot/HieropantCareer';
import JusticeCareer from './pages/CareerTarot/JusticeCareer';
import LoverCareer from './pages/CareerTarot/LoverCareer';
import MoonCareer from './pages/CareerTarot/MoonCareer';
import PriestessCareer from './pages/CareerTarot/PriestessCareer';
import StarCareer from './pages/CareerTarot/StarCareer';
import SunCareer from './pages/CareerTarot/SunCareer';
import TemperanceCareer from './pages/CareerTarot/TemperanceCareer';
import TowerCareer from './pages/CareerTarot/TowerCareer';
import WheeloffortuneCareer from './pages/CareerTarot/WheeloffortuneCareer';
import YesNoTarot from './pages/YesNoTarot';
import WorldYesno from './pages/Yes&no Tarot/WorldYesno';
import EmperorYesno from './pages/Yes&no Tarot/EmperorYesno';
import ChariotYesno from './pages/Yes&no Tarot/ChariotYesno';
import HangedmanYesno from './pages/Yes&no Tarot/HangedmanYesno';
import DeathYesno from './pages/Yes&no Tarot/DeathYesno';
import HermitYesno from './pages/Yes&no Tarot/HermitYesno';
import HierophantYesno from './pages/Yes&no Tarot/HierophantYesno';
import JusticeYesno from './pages/Yes&no Tarot/JusticeYesno';
import LoverYesno from './pages/Yes&no Tarot/LoverYesno';
import MoonYesno from './pages/Yes&no Tarot/MoonYesno';
import PricestessYesno from './pages/Yes&no Tarot/PricestessYesno';
import StarYesno from './pages/Yes&no Tarot/StarYesno';
import SunYesno from './pages/Yes&no Tarot/SunYesno';
import TemperanceYesno from './pages/Yes&no Tarot/TemperanceYesno';
import TowerYesno from './pages/Yes&no Tarot/TowerYesno';
import WheelofFortuneYesno from './pages/Yes&no Tarot/WheelofFortuneYesno';
import LovePotentialTarot from './pages/LovePotentialTarot';
import WorldLovers from './pages/Love Potential/WorldLovers';
import EmperorLovers from './pages/Love Potential/EmperorLovers';
import ChariotLovers from './pages/Love Potential/ChariotLovers';
import HangedmanLovers from './pages/Love Potential/HangedmanLovers';
import DeathLovers from './pages/Love Potential/DeathLovers';
import HermitLovers from './pages/Love Potential/HermitLovers';
import HierophantLovers from './pages/Love Potential/HierophantLovers';
import JusticeLovers from './pages/Love Potential/JusticeLovers';
import LoversLovers from './pages/Love Potential/LoversLovers';
import MoonLovers from './pages/Love Potential/MoonLovers';
import PricestessLovers from './pages/Love Potential/PricestessLovers';
import StarLovers from './pages/Love Potential/StarLovers';
import SunLovers from './pages/Love Potential/SunLovers';
import TemperanceLovers from './pages/Love Potential/TemperanceLovers';
import TowerLovers from './pages/Love Potential/TowerLovers';
import WheelofFortuneLovers from './pages/Love Potential/WheelofFortuneLovers';
import FlirtTarot from './pages/FlirtTarot';
import WorldFlirt from './pages/Flirt Tarot/WorldFlirt';
import EmperorFlirt from './pages/Flirt Tarot/EmperorFlirt';
import ChariotFlirt from './pages/Flirt Tarot/ChariotFlirt';
import HangedmanFlirt from './pages/Flirt Tarot/HangedmanFlirt';
import DeathFlirt from './pages/Flirt Tarot/DeathFlirt';
import HermitFlirt from './pages/Flirt Tarot/HermitFlirt';
import HierophantFlirt from './pages/Flirt Tarot/HierophantFlirt';
import JusticeFlirt from './pages/Flirt Tarot/JusticeFlirt';
import LoverFlirt from './pages/Flirt Tarot/LoverFlirt';
import MoonFlirt from './pages/Flirt Tarot/MoonFlirt';
import PricestessFlirt from './pages/Flirt Tarot/PricestessFlirt';
import StarFlirt from './pages/Flirt Tarot/StarFlirt';
import SunFlirt from './pages/Flirt Tarot/SunFlirt';
import TempranceFlirt from './pages/Flirt Tarot/TempranceFlirt';
import WheelofFortuneFlirt from './pages/Flirt Tarot/WheelofFortuneFlirt';
import TowerFlirt from './pages/Flirt Tarot/TowerFlirt';
import BreakupTarot from './pages/BreakupTarot';
import Dummy from './pages/Kundli';
import AstroNumero from './pages/AstroNumero';
import NumeroCompatibility from './pages/NumeroCompatibility';
import AuthGuard from './pages/AuthGuard';
import { AuthProvider, AuthContext } from './pages/AuthContext';
import { useEffect, useContext, Suspense, useState } from 'react';
import PrivateRoute from './components/PrivateRoute';
import BlogAdminPrivateRoute from './components/BlogAdminPrivateRoute';
import Panchang from './pages/panchang/Panchang';
import FlipCard from "./pages/panchang/FlipCard";
import NatalChart from './pages/NatalChart';
import NatalChartResult from './pages/NatalChartResult';
import KundliResult from './pages/KundliResult';
import ChaughadiyaPanchang from './pages/panchang/ChaughadiyaPanchang';
import HoraPanchang from './pages/panchang/HoraPanchang';
import DailyHoroscope from './pages/DailyHoroscope';
import YearlyHoroscope from './pages/YearlyHoroscope';
import WeeklyHoroscope from './pages/WeeklyHoroscope';
import KundliMatchingResult from './pages/KundliMatchingResult';
import Dummyn from './pages/Dummyn';
import NewKundli from './pages/NewKundli';
import LoveCompatibilityResult from './pages/LoveCompatibilityResult';
import UserProfile from './pages/UserProfile';
import BlogHome from './pages/AstroBlog/BlogHome';
import BlogPage from './pages/AstroBlog/BlogPage';
import BlogAdmin from './pages/AstroBlog/BlogAdmin';
import BlogLogin from './pages/AstroBlog/BlogLogin';
import BlogSignup from './pages/AstroBlog/BlogSignup';
import AdminDashboard from './pages/Admin/AdminDashboard';
import PdfFormDetails from './pages/Report Payment/PdfFormDetails';
import PdfReportDetails from './pages/Report Payment/PdfReportDetails';
import DoshaCalculator from './pages/DoshaCalculator';
import DoshaCalculatorResult from './pages/DoshaCalculatorResult';
import AdminRoute from './components/AdminRoute';
import CommingSoon from './pages/CommingSoon';
import VerifyEmailPassword from './auth/VerifyEmailPassword';
import Loader from './pages/Loader';

// Helper function to create unique hash-based IDs
const generateUniqueId = (cardName) => {
  const hash = crypto.MD5(cardName).toString(crypto.enc.Base64); // Hash the card name and convert to Base64
  return hash.substring(0, 25); // Take the first 5 characters for the unique ID
};

// Helper function to create protected route
const createProtectedRoute = (path, Component) => {
  return <Route path={path} element={<PrivateRoute><Component /></PrivateRoute>} />;
};

function App() {
  const { setIsLogged } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true); // State to track loading status

  useEffect(() => {
    // Simulate website loading
    const timer = setTimeout(() => {
      setIsLoading(false); // Set loading to false after 2 seconds
    }, 2000);

    // Check for existing session
    const checkAuth = () => {
      const userSession = localStorage.getItem('userSession');
      const authToken = localStorage.getItem('authToken');

      if (userSession && authToken) {
        const session = JSON.parse(userSession);
        if (session.isLoggedIn) {
          setIsLogged(true);
        }
      }
    };

    checkAuth();

    return () => clearTimeout(timer); // Cleanup timeout on component unmount
  }, [setIsLogged]);

  if (isLoading) {
    return <Loader />; // Show Loader while the website is loading
  }

  return (
    <AuthProvider>
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Public Routes (Login & Signup) */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-pass/:token" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path='/verify-forgotpassword' element={<VerifyEmailPassword />} />
          <Route path="/" element={<MainLayout />} />
          {/* Protected Routes */}
          <Route>
            <Route path="/horoscope" element={<Horoscope />} />
            {/* <Route path="/dummy" element={<Dummyn />} /> */}
            {/* <Route path="/kundli" element={<Kundli />} /> */}
            {/* <Route path="/learn" element={<Learn />} /> */}
            <Route path='/new-kundli' element={<NewKundli />} />
            <Route path="/numero" element={<Numero />} />
            <Route path="/tarot" element={<Tarot />} />
            <Route path="/compatibility" element={<Compatiblity />} />
            <Route path="/kundlimatching" element={<KundliMatching />} />
            <Route path="/love/compatibility" element={<LoveCompatibility />} />
            <Route path="/love/tarot" element={<LoveTarot />} />
            <Route path="/work/compatibility" element={<WorkCompatibility />} />
            <Route path="/chinese/compatibility" element={<ChineseCompatibility />} />
            <Route path="/daily/tarot" element={<DailyTarot />} />
            <Route path="/career/tarot" element={<CareerTarot />} />
            <Route path="/yes&no/tarot" element={<YesNoTarot />} />
            <Route path="/lovepotential/tarot" element={<LovePotentialTarot />} />
            <Route path="/flirt/tarot" element={<FlirtTarot />} />
            <Route path="/breakup/tarot" element={<BreakupTarot />} />
            <Route path="/daily/panchang" element={<Panchang />} />
            {/* <Route path="/astro/numero" element={<AstroNumero />} /> */}
            {/* <Route path="/flipcard" element={<FlipCard/>}/> */}
            <Route path="/natalchart" element={<NatalChart />} />
            <Route path="/chaughadiya/panchang" element={<ChaughadiyaPanchang />} />
            <Route path='/hora/panchang' element={<HoraPanchang />} />
            <Route path='/daily-horoscope' element={<DailyHoroscope />} />
            <Route path='/yearly-horoscope' element={<YearlyHoroscope />} />
            <Route path='/weekly-horoscope' element={<WeeklyHoroscope />} />
            {/* <Route path="/astroblog/:id" element={<BlogForm/>}/> */}
            <Route path="/blog" element={<BlogHome />} />
            <Route path="/blog/:blogTitle" element={<BlogPage />} />
            <Route path="/blog/admin" element={<BlogAdminPrivateRoute><BlogAdmin /></BlogAdminPrivateRoute>} />
            <Route path="/blog/admin-login" element={<BlogLogin />} />
            <Route path="/comming-soon" element={<CommingSoon />} />
            <Route path="/admin-dashboard" element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } />
            {/* <Route path="/blog/admin-signup" element={<BlogSignup/>}/> */}
            {/* <Route path="/pdf-details-form" element={<PdfFormDetails/>}/> */}
            {/* <Route path="/pdf-report" element={<PdfReportDetails/>}/> */}
            {/* <Route path="/dosha-calculator" element={<DoshaCalculator/>}/> */}
            {/* <Route path="/dosha-calculator-result" element={<DoshaCalculatorResult />}/> */}

            {createProtectedRoute("/kundliresult", KundliResult)}
            {createProtectedRoute("/natalchart/result", NatalChartResult)}
            {createProtectedRoute("/profile", UserProfile)}
            {createProtectedRoute('/kundli-matching-result', KundliMatchingResult)}
            {createProtectedRoute("/love-compatibility-result", LoveCompatibilityResult)}
            {/*Daily Tarot child card routes with hashed unique 5-digit IDs */}
            {createProtectedRoute(`/tarot/${generateUniqueId('World')}`, WorldCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Emperor')}`, EmperorCards)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Chariot')}`, ChariotCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Hangedman')}`, HangedmanCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Death')}`, DeathCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Hermit')}`, HermitCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Hierophant')}`, Hieropant)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Justice')}`, Justicecard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Lovers')}`, LoverCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Moon')}`, MoonCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Priestess')}`, PriestessCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Star')}`, StarCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Sun')}`, SunCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Temperance')}`, TemperanceCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Tower')}`, TowerCard)}
            {createProtectedRoute(`/tarot/${generateUniqueId('Wheelfortune')}`, WheelfortuneCard)}


            {/* Love Tarot child card routes with hashed unique 5-digit IDs */}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('World')}`, WorldLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Emperor')}`, EmperorLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Chariot')}`, ChariotLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Hangedman')}`, HangedmanLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Death')}`, DeathLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Hermit')}`, HermitLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Hierophant')}`, HieropantLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Justice')}`, JusticeLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Lovers')}`, LoverLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Moon')}`, MoonLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Priestess')}`, PriestessLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Star')}`, StarLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Sun')}`, SunLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Temperance')}`, TemperanceLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Tower')}`, TowerLove)}
            {createProtectedRoute(`/love/tarot/${generateUniqueId('Wheelfortune')}`, WheelfortuneLove)}

            {/* Career Tarot child card routes with hashed unique 10-digit IDs */}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('World')}`, WorldCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Emperor')}`, EmperorCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Chariot')}`, ChariotCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Hangedman')}`, HangedmanCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Death')}`, DeathCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Hermit')}`, HermitLove)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Hierophant')}`, HieropantCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Justice')}`, JusticeCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Lovers')}`, LoverCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Moon')}`, MoonCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Priestess')}`, PriestessCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Star')}`, StarCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Sun')}`, SunCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Temperance')}`, TemperanceCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Tower')}`, TowerCareer)}
            {createProtectedRoute(`/career/tarot/${generateUniqueId('Wheelfortune')}`, WheeloffortuneCareer)}

            {/* Yes&No Tarot child card routes with hashed unique 10-digit IDs */}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('World')}`, WorldYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Emperor')}`, EmperorYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Chariot')}`, ChariotYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Hangedman')}`, HangedmanYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Death')}`, DeathYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Hermit')}`, HermitYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Hierophant')}`, HierophantYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Justice')}`, JusticeYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Lovers')}`, LoverYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Moon')}`, MoonYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Priestess')}`, PricestessYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Star')}`, StarYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Sun')}`, SunYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Temperance')}`, TemperanceYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Tower')}`, TowerYesno)}
            {createProtectedRoute(`/yes&no/tarot/${generateUniqueId('Wheelfortune')}`, WheelofFortuneYesno)}

            {/* Love Potential Tarot child card routes with hashed unique 10-digit IDs */}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('World')}`, WorldLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Emperor')}`, EmperorLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Chariot')}`, ChariotLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Hangedman')}`, HangedmanLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Death')}`, DeathLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Hermit')}`, HermitLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Hierophant')}`, HierophantLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Justice')}`, JusticeLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Lovers')}`, LoversLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Moon')}`, MoonLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Priestess')}`, PricestessLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Star')}`, StarLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Sun')}`, SunLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Temperance')}`, TemperanceLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Tower')}`, TowerLovers)}
            {createProtectedRoute(`/lovepotential/tarot/${generateUniqueId('Wheelfortune')}`, WheelofFortuneLovers)}

            {/* Love Potential Tarot child card routes with hashed unique 10-digit IDs */}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('World')}`, WorldFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Emperor')}`, EmperorFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Chariot')}`, ChariotFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Hangedman')}`, HangedmanFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Death')}`, DeathFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Hermit')}`, HermitFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Hierophant')}`, HierophantFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Justice')}`, JusticeFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Lovers')}`, LoverFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Moon')}`, MoonFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Priestess')}`, PricestessFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Star')}`, StarFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Sun')}`, SunFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Temperance')}`, TempranceFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Tower')}`, TowerFlirt)}
            {createProtectedRoute(`/flirt/tarot/${generateUniqueId('Wheelfortune')}`, WheelofFortuneFlirt)}

          </Route>
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

export default App;